import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DEFAULT_PLAN_CATALOG, PlanCatalogEntry, TenantPlan } from '@models';
import { FirestoreService } from './firestore.service';

const COLLECTION = 'plan_catalog';

@Injectable({ providedIn: 'root' })
export class PlanCatalogService {
  private readonly firestore = inject(FirestoreService);

  /** All plan definitions, ordered by sortOrder. */
  listAll(): Observable<PlanCatalogEntry[]> {
    return this.firestore.listDocuments<PlanCatalogEntry>(COLLECTION);
  }

  /** Single plan definition. */
  get(id: string): Observable<PlanCatalogEntry> {
    return this.firestore.getDocument<PlanCatalogEntry>(COLLECTION, id);
  }

  /** Save (create or update) a plan definition. */
  save(entry: PlanCatalogEntry): Promise<void> {
    return this.firestore.createOrUpdate<PlanCatalogEntry>(COLLECTION, entry.id, entry);
  }

  /**
   * Seeds the catalog with DEFAULT_PLAN_CATALOG entries using deterministic IDs.
   * Safe to call multiple times — will overwrite existing entries.
   */
  async seedDefaults(): Promise<void> {
    const writes = DEFAULT_PLAN_CATALOG.map((entry) => {
      const id = `${entry.tenantType}_${entry.plan}`;
      return this.save({ ...entry, id });
    });
    await Promise.all(writes);
  }
}
